import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "list_container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "group_item_arrow"
}

import { emitWithPreviewCheck, GroupList, setActiveItemFromClick, setFirstActiveItem } from '@/view/home/supportScript';
import { ref, onMounted, computed, onBeforeMount } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'groupList',
  props: {
    listData: {},
    itemData: {}
  },
  emits: ['goToGamePanel'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const customStyles = ref({
    active_background_color: '',
    active_font_color: "",
    border_color: "",
    font_color: ""
})
const props = __props
const localActiveItem = ref<string | number>('')

const activeItem = computed({
  get: () => localActiveItem.value || props.listData[0]?.id || '',
  set: (val) => {
    localActiveItem.value = val
  }
})
const emits = __emit

const hexWithAlpha = (hex: string, alpha: number) => {
    return hex + Math.round(alpha * 255).toString(16).padStart(2, '0')
}
const color1 = computed(() => customStyles.value.active_background_color)
const color2 = computed(() => hexWithAlpha(color1.value, 0))
const color3 = computed(() => hexWithAlpha(color1.value, 0.5))
const color4 = computed(() => hexWithAlpha(color1.value, 0.04))

const setActiopFunGroup = (item: any) => {
    setActiveItemFromClick(item, localActiveItem)
}

const goToGamePannel = (id: number | string, groupType: number) => {
    let data = {
        id: id,
        groupType: groupType
    }
    emitWithPreviewCheck(emits, 'goToGamePanel', data)
}

const setActiveItem = () => {
    setFirstActiveItem(props.listData, localActiveItem)
}
__expose({
    setActiveItem,
})

onBeforeMount(()=>{
    setActiveItem();
});

onMounted(() => {
    customStyles.value.active_background_color = props.itemData.styles.active_background_color
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
    customStyles.value.font_color = props.itemData.styles.font_color
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        onClick: ($event: any) => (setActiopFunGroup(item))
      }, [
        _createElementVNode("div", {
          class: "group_item",
          style: _normalizeStyle({
                border: `1px solid ${customStyles.value.border_color}`,
                color: item.id === activeItem.value ? customStyles.value.active_font_color : customStyles.value.font_color,
                background: item.id === activeItem.value
                    ? '#dd8b3345'
                    : ''
            }),
          onClick: ($event: any) => (goToGamePannel(item.id, item.groupType))
        }, [
          _createElementVNode("img", {
            src: item.customIcon,
            alt: ""
          }, null, 8, _hoisted_4),
          (item.id === activeItem.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : _createCommentVNode("", true)
        ], 12, _hoisted_3)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})